import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-gadar`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

function printByRegister(register_id) {
  window.open(
    `${http.getAPI()}/register/${register_id}/asesmen-awal-gadar/pdf`,
    "_blank"
  );
}

// asesmen-awal-gadar/pdf

export default {
  getByRegister,
  printByRegister
};
